import React from 'react'

const ColumnDescription = () => {
  return (
    <div>ColumnDescription</div>
  )
}

export default ColumnDescription